"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandEnum = exports.SelectTheme = exports.grupoTheme = exports.contrastTheme = exports.eamTheme = exports.ouiTheme = exports.eudoraTheme = exports.boticarioTheme = exports.floraTheme = exports.mleTheme = exports.mlbTheme = void 0;
// Minha Loja
const minhalojaboticario_1 = __importDefault(require("./minhalojaboticario"));
exports.mlbTheme = minhalojaboticario_1.default;
const minhalojaeudora_1 = __importDefault(require("./minhalojaeudora"));
exports.mleTheme = minhalojaeudora_1.default;
// Design System
const flora_default_1 = __importDefault(require("./flora-default"));
exports.floraTheme = flora_default_1.default;
const boticario_1 = __importDefault(require("./boticario"));
exports.boticarioTheme = boticario_1.default;
const eudora_1 = __importDefault(require("./eudora"));
exports.eudoraTheme = eudora_1.default;
const oui_1 = __importDefault(require("./oui"));
exports.ouiTheme = oui_1.default;
const eam_1 = __importDefault(require("./eam"));
exports.eamTheme = eam_1.default;
const grupo_1 = __importDefault(require("./grupo"));
exports.grupoTheme = grupo_1.default;
const contrast_1 = __importDefault(require("./contrast"));
exports.contrastTheme = contrast_1.default;
var BrandEnum;
(function (BrandEnum) {
    BrandEnum[BrandEnum["boticario"] = 0] = "boticario";
    BrandEnum[BrandEnum["eudora"] = 1] = "eudora";
    BrandEnum[BrandEnum["oui"] = 2] = "oui";
    BrandEnum[BrandEnum["eam"] = 3] = "eam";
    BrandEnum[BrandEnum["euamomake"] = 4] = "euamomake";
    BrandEnum[BrandEnum["grupo"] = 5] = "grupo";
    BrandEnum[BrandEnum["default"] = 6] = "default";
})(BrandEnum || (BrandEnum = {}));
exports.BrandEnum = BrandEnum;
const SelectTheme = (brand, theme, contrast) => {
    if (!brand) {
        return theme && theme.name ? theme : flora_default_1.default;
    }
    switch (brand) {
        case 'boticario':
            if (contrast) {
                return Object.assign(Object.assign({}, boticario_1.default), { colors: Object.assign({}, contrast_1.default.colors) });
            }
            return boticario_1.default;
        case 'eudora':
            if (contrast) {
                return Object.assign(Object.assign({}, eudora_1.default), { colors: Object.assign({}, contrast_1.default.colors) });
            }
            return eudora_1.default;
        case 'oui':
            return oui_1.default;
        case 'eam':
        case 'euamomake':
            return eam_1.default;
        case 'grupo':
            return grupo_1.default;
        default:
            return flora_default_1.default;
    }
};
exports.SelectTheme = SelectTheme;
